import React from "react";
import Main from "./pages/Main";
import "./App.scss";

export default function App() {
  return <Main />;
}
